import React, { Component } from 'react'

class Loading extends Component {
  render() {
    return (
      <div className="loading">
        <div class="waviy">
         <span style={{ '--i': '1' }}>T</span>
         <span style={{ '--i': '2' }}>R</span>
         <span style={{ '--i': '3' }}>A</span>
         <span style={{ '--i': '4' }}>P</span>
         <span style={{ '--i': '5' }}>I</span>
         <span style={{ '--i': '6' }}>N</span>
         <span style={{ '--i': '7' }}>K</span>
         <span className="waviy__period" style={{ '--i': '8' }}>.</span>
        </div>
      </div>
    )
  }
}

export default Loading;



// WEBPACK FOOTER //
// ./src/components/loading/index.js